var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"total":_vm.total},on:{"delete":function($event){return _vm.$emit('delete', $event)},"edit":_vm.edit}})
}
var staticRenderFns = []

export { render, staticRenderFns }